import React, { useEffect, useState } from "react";
import style from "../../../FormFiveLightTheme/Form/formfivelighttheme.module.scss";
import AutoCompleteField from "../../../../components/AutoCompleteField/AutoCompleteField";
import CustomCheckBoxInput from "../../../../components/CustomCheckBoxInput/CustomCheckBoxInput";
import { useBusinessContext } from "../../../../context/BusinessAccount/BusinessAccountState";
import Joi from "joi";
import config from "../../../../config/config";
import http from "../../../../helpers/http";
import { toast } from "react-toastify";
import ToastMsg from "../../../../components/ToastMsg/ToastMsg";
import helper from "../../../../helpers/helper";
import useTheme from "../../../../components/useTheme/useTheme";

const EnquiryPreferenceForm = () => {
  const {theme} = useTheme()
  const businessTypesOptions = [
    {
      index: "1",
      options: [
        "Project/Business",
        "Product/Material Showcase",
        "Jobs/Internship/Hiring",
        "Media/PR/Events",
      ],
    },
    {
      index: "2",
      options: [
        "Project/Business",
        "Product/Material Showcase",
        "Jobs/Internship/Hiring",
        "Media/PR/Events",
      ],
    },
    {
      index: "3",
      options: ["Product/Material Showcase", "Media / PR / Events"],
    },
    {
      index: "4",
      options: ["Product/Material Showcase", "Media / PR / Events"],
    },
    {
      index: "5",
      options: [
        "Project/Business",
        "Jobs/Internship/Hiring",
        "Media/PR/Events",
      ],
    },
    {
      index: "6",
      options: [
        "Project/Business",
        "Product/Material Showcase",
        "Jobs/Internship/Hiring",
        "Media/PR/Events",
      ],
    },
  ];

  const { data, update, fetchData } = useBusinessContext();
  const [formError, setFormError] = useState({});
  const [displayedOptions, setDisplayedOptions] = useState([]);
  const [formData, setFormData] = useState({
    enquiry_preferences: {
      projects_business: {
        contact_person: "Both",
        contact_methods: ["Email Id", "WhatsApp"],
      },
      product_material: {
        contact_person: "Both",
        contact_methods: ["Email Id", "WhatsApp"],
      },
      jobs_internships: {
        contact_person: "Both",
        contact_methods: ["Email Id", "WhatsApp"],
      },
      media_pr: {
        contact_person: "Both",
        contact_methods: ["Email Id", "WhatsApp"],
      },
    },
  });

  const countries = [
    {
      label: "Owner/s",
      value: "Owner/s",
    },
    {
      label: "Business Contact Person",
      value: "Business Contact Person",
    },
    {
      label: "Both",
      value: "Both",
    },
  ];

  const contactMethodOptions = [
    { label: "Email Id", value: "Email Id" },
    { label: "WhatsApp", value: "WhatsApp" },
    { label: "Phone Call", value: "Phone Call" },
  ];

  useEffect(() => {
    if (!data?._id) return;

    setDisplayedOptions([]);
    setFormError({});

    setFormData({
      enquiry_preferences: {
        projects_business: {
          contact_person: "Both",
          contact_methods: ["Email Id", "WhatsApp"],
        },
        product_material: {
          contact_person: "Both",
          contact_methods: ["Email Id", "WhatsApp"],
        },
        jobs_internships: {
          contact_person: "Both",
          contact_methods: ["Email Id", "WhatsApp"],
        },
        media_pr: {
          contact_person: "Both",
          contact_methods: ["Email Id", "WhatsApp"],
        },
      },
    });
  }, [data?._id]);

  // useEffect(() => {
  //   if (data?.enquiry_preferences) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       enquiry_preferences: {
  //         projects_business: {
  //           contact_person:
  //             data.enquiry_preferences.projects_business?.contact_person ||
  //             "Both",
  //           contact_methods: data.enquiry_preferences.projects_business
  //             ?.contact_methods?.length
  //             ? data.enquiry_preferences.projects_business?.contact_methods
  //             : ["Email Id", "WhatsApp"],
  //         },
  //         product_material: {
  //           contact_person:
  //             data.enquiry_preferences.product_material?.contact_person ||
  //             "Both",
  //           contact_methods: data.enquiry_preferences.product_material
  //             ?.contact_methods?.length
  //             ? data.enquiry_preferences.product_material?.contact_methods
  //             : ["Email Id", "WhatsApp"],
  //         },
  //         jobs_internships: {
  //           contact_person:
  //             data.enquiry_preferences.jobs_internships?.contact_person ||
  //             "Both",
  //           contact_methods: data.enquiry_preferences.jobs_internships
  //             ?.contact_methods?.length
  //             ? data.enquiry_preferences.jobs_internships?.contact_methods
  //             : ["Email Id", "WhatsApp"],
  //         },
  //         media_pr: {
  //           contact_person:
  //             data.enquiry_preferences.media_pr?.contact_person || "Both",
  //           contact_methods: data.enquiry_preferences.media_pr?.contact_methods
  //             ?.length
  //             ? data.enquiry_preferences.media_pr?.contact_methods
  //             : ["Email Id", "WhatsApp"],
  //         },
  //       },
  //     }));
  //   }

  //   const businessTypes = data?.business_types || [];
  //   const prefixes = businessTypes.map((bt) => bt.prefix);
  //   if (prefixes.length > 0) {
  //     const relevantOptions = businessTypesOptions.filter((opt) =>
  //       prefixes.includes(opt.index),
  //     );
  //     if (relevantOptions.length > 0) {
  //       const bestOption = relevantOptions.reduce((prev, current) =>
  //         prev.options.length > current.options.length ? prev : current,
  //       );
  //       setDisplayedOptions(bestOption.options);
  //     }
  //   }
  // }, [data]);

  useEffect(() => {
    if (!data?.enquiry_preferences) return;

    setFormData({
      enquiry_preferences: {
        projects_business: {
          contact_person:
            data.enquiry_preferences.projects_business?.contact_person ||
            "Both",
          contact_methods: data.enquiry_preferences.projects_business
            ?.contact_methods?.length
            ? data.enquiry_preferences.projects_business.contact_methods
            : ["Email Id", "WhatsApp"],
        },
        product_material: {
          contact_person:
            data.enquiry_preferences.product_material?.contact_person || "Both",
          contact_methods: data.enquiry_preferences.product_material
            ?.contact_methods?.length
            ? data.enquiry_preferences.product_material.contact_methods
            : ["Email Id", "WhatsApp"],
        },
        jobs_internships: {
          contact_person:
            data.enquiry_preferences.jobs_internships?.contact_person || "Both",
          contact_methods: data.enquiry_preferences.jobs_internships
            ?.contact_methods?.length
            ? data.enquiry_preferences.jobs_internships.contact_methods
            : ["Email Id", "WhatsApp"],
        },
        media_pr: {
          contact_person:
            data.enquiry_preferences.media_pr?.contact_person || "Both",
          contact_methods: data.enquiry_preferences.media_pr?.contact_methods
            ?.length
            ? data.enquiry_preferences.media_pr.contact_methods
            : ["Email Id", "WhatsApp"],
        },
      },
    });
  }, [data?.enquiry_preferences]);

  useEffect(() => {
    const businessTypes = data?.business_types || [];
    const prefixes = businessTypes.map((bt) => bt.prefix);

    if (!prefixes.length) {
      setDisplayedOptions([]); // VERY IMPORTANT
      return;
    }

    const relevantOptions = businessTypesOptions.filter((opt) =>
      prefixes.includes(opt.index),
    );

    if (relevantOptions.length) {
      const bestOption = relevantOptions.reduce((prev, current) =>
        prev.options.length > current.options.length ? prev : current,
      );

      setDisplayedOptions(bestOption.options);
    } else {
      setDisplayedOptions([]); // VERY IMPORTANT
    }
  }, [data?.business_types]);

  const shouldRenderOption = (optionName) => {
    const normalizedOptionName = optionName.replace(/\s/g, "").toLowerCase();
    return displayedOptions.some(
      (opt) => opt.replace(/\s/g, "").toLowerCase() === normalizedOptionName,
    );
  };

  const handleSelectChange = (value, category) => {
    setFormData((prev) => ({
      ...prev,
      enquiry_preferences: {
        ...prev.enquiry_preferences,
        [category]: {
          ...prev.enquiry_preferences[category],
          contact_person: value || "Both",
        },
      },
    }));
  };

  const handleCheckboxChange = (category, value, isChecked) => {
    setFormData((prev) => {
      const currentMethods = [
        ...prev.enquiry_preferences[category].contact_methods,
      ];

      if (isChecked) {
        // Add value if not present
        if (!currentMethods.includes(value)) {
          currentMethods.push(value);
        }
      } else {
        // Remove value if present
        const index = currentMethods.indexOf(value);
        if (index !== -1) {
          currentMethods.splice(index, 1);
        }
      }

      return {
        ...prev,
        enquiry_preferences: {
          ...prev.enquiry_preferences,
          [category]: {
            ...prev.enquiry_preferences[category],
            contact_methods: currentMethods,
          },
        },
      };
    });
  };

  const validate = async (data) => {
    const enquiryPreferencesSchema = {};

    if (shouldRenderOption("Project/ Business")) {
      enquiryPreferencesSchema.projects_business = Joi.object({
        contact_person: Joi.string().required().messages({
          "string.empty": "Select a contact person option",
          "any.required": "Select a contact person option",
        }),
        contact_methods: Joi.array().min(1).required().messages({
          "array.min": "Select at least one contact method",
          "any.required": "Select at least one contact method",
        }),
      }).required();
    }

    if (shouldRenderOption("Product / Material Showcase")) {
      enquiryPreferencesSchema.product_material = Joi.object({
        contact_person: Joi.string().required().messages({
          "string.empty": "Select a contact person option",
          "any.required": "Select a contact person option",
        }),
        contact_methods: Joi.array().min(1).required().messages({
          "array.min": "Select at least one contact method",
          "any.required": "Select at least one contact method",
        }),
      }).required();
    }

    if (shouldRenderOption("Jobs/ Internship / Hiring")) {
      enquiryPreferencesSchema.jobs_internships = Joi.object({
        contact_person: Joi.string().required().messages({
          "string.empty": "Select a contact person option",
          "any.required": "Select a contact person option",
        }),
        contact_methods: Joi.array().min(1).required().messages({
          "array.min": "Select at least one contact method",
          "any.required": "Select at least one contact method",
        }),
      }).required();
    }

    if (shouldRenderOption("Media / PR /Events")) {
      enquiryPreferencesSchema.media_pr = Joi.object({
        contact_person: Joi.string().required().messages({
          "string.empty": "Select a contact person option",
          "any.required": "Select a contact person option",
        }),
        contact_methods: Joi.array().min(1).required().messages({
          "array.min": "Select at least one contact method",
          "any.required": "Select at least one contact method",
        }),
      }).required();
    }

    const schema = Joi.object({
      enquiry_preferences: Joi.object(enquiryPreferencesSchema).required(),
    }).options({ allowUnknown: true });
    const { error } = schema.validate(data, config.joiOptions);

    const errors = {};
    if (error) {
      error.details.forEach((field) => {
        // Extract the specific path for nested errors
        if (field.path.length > 2) {
          const category = field.path[1]; // projects_business, product_material, etc.
          const field_type = field.path[2]; // contact_person or contact_methods
          errors[`${category}_${field_type}`] = field.message;
        } else {
          errors[field.path[0]] = field.message;
        }
      });
    }

    return errors;
  };

  const handleSubmit = async () => {
    let errors = await validate(formData);
    setFormError(errors);

    if (Object.keys(errors).length) {
      helper.scroll(helper.getFirstError(errors));
      return;
    }

    callApi();
  };

  const callApi = async () => {
    try {
      const res = await http.post(
        `${config.api_url}/business/business-details/${data?._id}`,
        {
          ...formData,
        },
      );

      if (res) {
        update({
          ...data,
          ...formData,
        });

        toast(
          <ToastMsg message={`Changes saved successfully`} />,
          config.success_toast_config,
        );
      }
    } catch (error) {
      toast(<ToastMsg message="Failed to save" />, config.error_toast_config);
    }
  };

  const hasAnyVisibleOption = () => {
    if (!data?.business_types?.length) return false;

    return (
      shouldRenderOption("Project/Business") ||
      shouldRenderOption("Product / Material Showcase") ||
      shouldRenderOption("Jobs/ Internship / Hiring") ||
      shouldRenderOption("Media / PR /Events")
    );
  };

  return (
    <div className={`enquiry_preference_form_wrapper mt-4 pt-4 ${theme === "dark" && "enquiry_preference_form_wrapper--dark"}`}>
      {/* <h2 className="heading_common_contact_info mb-4 mb-mob--enq">
        How would you like to receive your enquiries for the following?*
      </h2> */}
      {hasAnyVisibleOption() && (
        <h2 className="heading_common_contact_info mb-4 mb-mob--enq">
          How would you like to receive your enquiries for the following?*
        </h2>
      )}

      <form
        action=""
        className="form_recive_queries d-flex justify-content-center"
      >
        <div
          className={`row ${style.spacing_rl_row_recive_queries}`}
          style={{
            maxWidth: "100%",
          }}
        >
          {shouldRenderOption("Project/Business") && (
            <div
              className={`col-lg-6 mb-col-6-enq ${style.rstep01_col}
            ${style.col_padding_recive_queries01}`}
            >
              <div
                className={`${style.field_wrapper} ${style.form_recive_queries_single_wrapper}`}
              >
                {/* <div className={style.heading_recive_queries}> */}
                <div
                  className={`heading_recive_queries--static ${style.heading_recive_queries}`}
                >
                  Projects/Business
                </div>
                <AutoCompleteField
                  lightTheme={theme === "dark" ? false : true}
                  key="projects_contact_person"
                  textLabel="Person to contact"
                  data={countries}
                  value={
                    countries.find(
                      (option) =>
                        option.value ===
                        formData.enquiry_preferences.projects_business
                          .contact_person,
                    ) || { value: "Both" }
                  }
                  onChange={(e, option) =>
                    handleSelectChange(
                      option.value || "Both",
                      "projects_business",
                    )
                  }
                  disablePortal
                />
                <div id="projects_business_contact_person_error">
                  {formError.projects_business_contact_person && (
                    <p className={style.error}>
                      {formError.projects_business_contact_person}
                    </p>
                  )}
                </div>

                {/* <p className={style.error}>
                        Error messsage here error messsage
                      </p> */}
                <div className={style.custom_check_box_warper_recive_queries}>
                  {contactMethodOptions.map((method, index) => (
                    <CustomCheckBoxInput
                    isLigthMode={theme === "light" ? true : false}
                      key={index}
                      label={method.label}
                      checked={formData?.enquiry_preferences?.projects_business?.contact_methods?.includes?.(
                        method.value,
                      )}
                      onChange={(e) =>
                        handleCheckboxChange(
                          "projects_business",
                          method.value,
                          e.target.checked,
                        )
                      }
                    />
                  ))}
                </div>
                <div id="projects_business_contact_methods_error">
                  {formError.projects_business_contact_methods && (
                    <p className={style.error}>
                      {formError.projects_business_contact_methods}
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}
          {shouldRenderOption("Product / Material Showcase") && (
            <div
              className={`col-lg-6 mb-col-6-enq  ${style.rstep01_col} ${style.col_padding_recive_queries02}`}
            >
              <div className={style.field_wrapper}>
                <div
                  className={`heading_recive_queries--static ${style.heading_recive_queries}`}
                >
                  Product/Material Showcase
                </div>
                <AutoCompleteField
                  lightTheme={theme === "dark" ? false : true}
                  key="product_material_contact_person"
                  textLabel="Person to contact"
                  data={countries}
                  value={
                    countries.find(
                      (option) =>
                        option.value ===
                        formData.enquiry_preferences.product_material
                          .contact_person,
                    ) || { value: "Both" }
                  }
                  onChange={(e, option) =>
                    handleSelectChange(
                      option.value || "Both",
                      "product_material",
                    )
                  }
                  disablePortal
                />
                <div id="product_material_contact_person_error">
                  {formError.product_material_contact_person && (
                    <p className={style.error}>
                      {formError.product_material_contact_person}
                    </p>
                  )}
                </div>

                {/* <p className={style.error}>
                        Error messsage here error messsage
                      </p> */}
                <div className={style.custom_check_box_warper_recive_queries}>
                  {contactMethodOptions.map((method, index) => (
                    <CustomCheckBoxInput
                    isLigthMode={theme === "light" ? true : false}
                      key={index}
                      label={method.label}
                      checked={formData?.enquiry_preferences?.product_material?.contact_methods?.includes?.(
                        method.value,
                      )}
                      onChange={(e) =>
                        handleCheckboxChange(
                          "product_material",
                          method.value,
                          e.target.checked,
                        )
                      }
                    />
                  ))}
                </div>
                <div id="product_material_contact_methods_error">
                  {formError.product_material_contact_methods && (
                    <p className={style.error}>
                      {formError.product_material_contact_methods}
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}
          {shouldRenderOption("Jobs/ Internship / Hiring") && (
            <div
              className={`col-lg-6 mb-col-6-enq  ${style.rstep01_col} ${style.col_padding_recive_queries03}`}
            >
              <div className={style.field_wrapper}>
                <div
                  className={`heading_recive_queries--static ${style.heading_recive_queries}`}
                >
                  Jobs/Internship/Hiring
                </div>
                <AutoCompleteField
                  lightTheme={theme === "dark" ? false : true}
                  key="jobs_internships_contact_person"
                  textLabel="Person to contact"
                  data={countries}
                  value={
                    countries.find(
                      (option) =>
                        option.value ===
                        formData.enquiry_preferences.jobs_internships
                          .contact_person,
                    ) || { value: "Both" }
                  }
                  onChange={(e, option) =>
                    handleSelectChange(
                      option.value || "Both",
                      "jobs_internships",
                    )
                  }
                  disablePortal
                />
                <div id="jobs_internships_contact_person_error">
                  {formError.jobs_internships_contact_person && (
                    <p className={style.error}>
                      {formError.jobs_internships_contact_person}
                    </p>
                  )}
                </div>

                {/* <p className={style.error}>
                        Error messsage here error messsage
                      </p> */}
                <div className={style.custom_check_box_warper_recive_queries}>
                  {contactMethodOptions.map((method, index) => (
                    <CustomCheckBoxInput
                    isLigthMode={theme === "light" ? true : false}
                      key={index}
                      label={method.label}
                      checked={formData?.enquiry_preferences?.jobs_internships?.contact_methods?.includes?.(
                        method.value,
                      )}
                      onChange={(e) =>
                        handleCheckboxChange(
                          "jobs_internships",
                          method.value,
                          e.target.checked,
                        )
                      }
                    />
                  ))}
                </div>
                <div id="jobs_internships_contact_methods_error">
                  {formError.jobs_internships_contact_methods && (
                    <p className={style.error}>
                      {formError.jobs_internships_contact_methods}
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}
          {shouldRenderOption("Media / PR /Events") && (
            <div
              className={`col-lg-6 mb-col-6-enq  ${style.rstep01_col} ${style.col_padding_recive_queries04}`}
            >
              <div className={style.field_wrapper}>
                <div
                  className={`heading_recive_queries--static ${style.heading_recive_queries}`}
                >
                  Media/PR/Events
                </div>
                <AutoCompleteField
                  lightTheme={theme === "dark" ? false : true}
                  key="media_pr_contact_person"
                  textLabel="Person to contact"
                  data={countries}
                  value={
                    countries.find(
                      (option) =>
                        option.value ===
                        formData.enquiry_preferences.media_pr.contact_person,
                    ) || { value: "Both" }
                  }
                  onChange={(e, option) =>
                    handleSelectChange(option.value || "Both", "media_pr")
                  }
                  disablePortal
                />
                <div id="media_pr_contact_person_error">
                  {formError.media_pr_contact_person && (
                    <p className={style.error}>
                      {formError.media_pr_contact_person}
                    </p>
                  )}
                </div>

                {/* <p className={style.error}>
                        Error messsage here error messsage
                      </p> */}
                <div className={style.custom_check_box_warper_recive_queries}>
                  {contactMethodOptions.map((method, index) => (
                    <CustomCheckBoxInput
                    isLigthMode={theme === "light" ? true : false}
                      key={index}
                      label={method.label}
                      checked={formData?.enquiry_preferences?.media_pr?.contact_methods?.includes?.(
                        method.value,
                      )}
                      onChange={(e) =>
                        handleCheckboxChange(
                          "media_pr",
                          method.value,
                          e.target.checked,
                        )
                      }
                    />
                  ))}
                </div>
                <div id="media_pr_contact_methods_error">
                  {formError.media_pr_contact_methods && (
                    <p className={style.error}>
                      {formError.media_pr_contact_methods}
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}
          {/* <div className="cta_wrapper--enquiry mt-4">
            <button
              type="button"
              className="bedit_common_cta"
              onClick={handleSubmit}
            >
              Save
            </button>
          </div> */}
          {hasAnyVisibleOption() && (
            <div className="cta_wrapper--enquiry mt-4">
              <button
                type="button"
                className="bedit_common_cta"
                onClick={handleSubmit}
              >
                Save
              </button>
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default EnquiryPreferenceForm;
{
  /* <div className="cta_wrapper mt-4">
          <button
            type="button"
            className="bedit_common_cta"
            onClick={handleSubmit}
          >
            Save
          </button>
        </div> */
}
